import { render, staticRenderFns } from "./Barra.vue?vue&type=template&id=4992a753"
import script from "./Barra.vue?vue&type=script&lang=js"
export * from "./Barra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports